export const WFH_DEDUCTION_OPTIONS = [
  { value: "HALF_DAY", label: "Half Day (Deduction Applied)" },
  { value: "FULL_DAY", label: "Full Day (No Deduction)" },
];
